"use client";

import React, { useMemo, useState } from "react";
import { motion } from "framer-motion";
import { shareOptions } from "@/utils/shareOptions";
import { ModalWrapper } from "./ModalWrapper";
import { useAppStore } from "@/store/useAppStore";

export const SocialChallengeModal = () => {
  const { userScore, challengeLink, setIsModalOpen, setActiveModal } =
    useAppStore();
  const [copied, setCopied] = useState(false);

  const copyToClipboard = async () => {
    await navigator.clipboard.writeText(challengeLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const shareOptionList = useMemo(
    () => shareOptions({ userScore, challengeLink }),
    [userScore, challengeLink]
  );

  const onClose = () => {
    setIsModalOpen(false);
    setActiveModal(null);
  };

  return (
    <ModalWrapper>
      <motion.div
        className="bg-white/10 backdrop-blur-xl rounded-3xl p-8 border border-white/20 max-w-md w-full"
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
      >
        <div className="text-center mb-6">
          <h3 className="text-2xl font-bold text-white mb-2">
            🎯 Challenge Created!
          </h3>
          <p className="text-gray-300">
            Your score to beat:{" "}
            <span className="text-green-400 font-bold">{userScore} points</span>
          </p>
        </div>

        <div className="bg-white/5 rounded-xl p-4 mb-6">
          <p className="text-xs text-gray-400 mb-2">Challenge Link:</p>
          <div className="flex items-center space-x-2">
            <input
              type="text"
              value={challengeLink}
              readOnly
              className="flex-1 bg-white/10 border border-white/20 rounded-lg px-3 py-2 text-sm text-white"
            />
            <button
              onClick={copyToClipboard}
              className="bg-brand-teal hover:bg-brand-teal text-white px-4 py-2 rounded-lg text-sm font-semibold transition-all"
            >
              {copied ? "✅" : "📋"}
            </button>
          </div>
        </div>

        <div className="space-y-3 mb-6">
          <p className="text-sm text-gray-300 text-center mb-3">
            Share your challenge:
          </p>
          <div className="grid grid-cols-2 gap-3">
            {shareOptionList.map((option) => (
              <button
                key={option.name}
                onClick={option.action}
                className="bg-white/10 hover:bg-white/20 border border-white/20 rounded-xl p-3 text-center transition-all"
              >
                <div className="text-2xl mb-1">{option.icon}</div>
                <div className="text-xs text-gray-300">{option.name}</div>
              </button>
            ))}
          </div>
        </div>

        <div className="hidden sm:block bg-gradient-to-r from-brand-teal/20 to-brand-amber/20 rounded-xl p-4 mb-6">
          <p className="text-sm text-center text-white">
            🏆 <strong>Winner gets:</strong> Exclusive "Mind Master" NFT Badge +
            500 bonus points!
          </p>
        </div>

        <button
          onClick={onClose}
          className="w-full bg-gray-700 hover:bg-gray-600 text-white py-3 rounded-xl font-semibold transition-all cursor-pointer"
        >
          Close
        </button>
      </motion.div>
    </ModalWrapper>
  );
};
